import React from 'react';
import { Link } from 'react-router-dom';
import './Credentials.css';

// ── UPDATE THIS SECTION WITH YOUR REAL INFORMATION ──
const founder = {
  name: 'Afzal Khan',
  title: 'Founder & Lead IT Engineer',
  bio: `Update this with your bio. Describe your background in IT, years of experience, and what drove you to start Bluepeak. 
  The more specific you are — certifications earned, industries served, problems solved — the more trust you build with prospective clients.`,
  certifications: [
    'CompTIA A+',
    'CompTIA Network+',
    'CompTIA Security+',
    'Microsoft Certified: Azure Administrator',
    // Add your real certifications here
  ],
  specializations: ['Managed IT Services', 'Cybersecurity', 'Law Firm IT', 'Endpoint Management'],
  // Replace with your actual LinkedIn URL
  linkedin: 'https://www.linkedin.com/in/afzal-khan/',
};

const values = [
  {
    title: 'Transparency first',
    desc: 'You will always know what we\'re doing, why we\'re doing it, and what it costs. No surprise invoices.',
  },
  {
    title: 'Regulated-industry fluent',
    desc: 'We understand privilege, confidentiality, and compliance. We speak your language.',
  },
  {
    title: 'Documentation-driven',
    desc: 'Every action we take is logged, documented, and available to you. Audit-ready by default.',
  },
  {
    title: 'Small team, full accountability',
    desc: 'When you call Bluepeak, you get the person who did the work — not a ticket number.',
  },
];

export default function Credentials() {
  return (
    <div className="credentials-page">
      <div className="page-hero">
        <div className="container">
          <span className="tag">Credentials</span>
          <h1>The team behind Bluepeak.</h1>
          <p>
            Bluepeak is a focused, founder-led practice. That means you always know
            who is responsible for your systems.
          </p>
        </div>
      </div>

      <div className="container cred-layout section">
        {/* Founder Card */}
        <div className="founder-card">
          <div className="founder-avatar">
            <span className="avatar-placeholder">
              {founder.name.split(' ').map(n => n[0]).join('')}
            </span>
          </div>
          <div className="founder-info">
            <h2>{founder.name}</h2>
            <p className="founder-title">{founder.title}</p>
            <p className="founder-bio">{founder.bio}</p>

            <div className="founder-specs">
              <div className="spec-block">
                <h4>Specializations</h4>
                <div className="tag-list">
                  {founder.specializations.map(s => (
                    <span key={s} className="spec-tag">{s}</span>
                  ))}
                </div>
              </div>
            </div>

            <a
              href={founder.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline linkedin-btn"
            >
              View LinkedIn Profile ↗
            </a>
          </div>
        </div>

        {/* Certifications */}
        <div className="certs-section">
          <span className="tag">Certifications & Qualifications</span>
          <div className="certs-grid">
            {founder.certifications.map(cert => (
              <div key={cert} className="cert-card">
                <span className="cert-badge">✓</span>
                <span className="cert-name">{cert}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Values */}
        <div className="values-section">
          <span className="tag">How we work</span>
          <h2>The Bluepeak standard.</h2>
          <div className="values-grid">
            {values.map(v => (
              <div key={v.title} className="value-card">
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="cred-cta">
          <h2>Let's talk about your environment.</h2>
          <p>A 30-minute call is all it takes to understand where you stand.</p>
          <Link to="/contact" className="btn-primary">Book a Consultation →</Link>
        </div>
      </div>
    </div>
  );
}
